<template>
  <div class="society">
    <div class="banner"></div>
    <div class="container">
      <div style="height: 0.82rem" v-if="!m"></div>
      <div style="height: 0.2rem" v-else></div>
      <div class="screen b-r">
        <h2 v-if="!m">职位筛选</h2>
        <h2 v-else>校园招聘</h2>
        <div class="main">
          <el-form :model="form" style="height: 100%">
            <div class="sle">
              <div class="sle_item">
                <el-form-item>
                  <el-input
                    v-model="form.name"
                    placeholder="请输入岗位名称"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="sle_item">
                <el-form-item>
                  <el-input
                    v-model="form.work_l"
                    placeholder="请输入工作地点"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="sle_item">
                <el-form-item>
                  <el-select
                    v-model="form.job_cate_id"
                    placeholder="请选择岗位类别"
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.name"
                      :value="item.type_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-button type="primary" @click="ClickQuery">查询</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="list">
        <!-- 判断显示列表内容还是显示空数据图 -->
        <ul class="list_item" v-if="!ListShow">
          <li
            class="item b-r"
            v-for="(item, index) in list"
            :key="index"
            path="/details"
          >
            <div class="item_l">
              <h4>{{ item.name }}</h4>
              <p>
                <span>{{ item.work_l }} | </span>
                <span>{{ item.job_cate_name }} | </span>
                <span>{{ item.education }}</span>
              </p>
            </div>
            <div class="item_r">
              <button @click="toDetails(item.j_id)">查看职位</button>
            </div>
          </li>
        </ul>
        <div v-else>
          <el-empty description="没有找到您想要的数据！！！"></el-empty>
        </div>
        <!-- 判断更多图标是否显示 -->
        <div v-if="moreBox">
          <!-- 判断显示更多图标还是显示没有更多的数据 -->
          <div v-if="MoreShow" class="more" @click="AddList">
            <div class="more_box more_top">
              <img src="../assets/img/xiala.png" alt="" />
            </div>
            <div class="more_box more_btm">
              <img src="../assets/img/xiala.png" alt="" />
            </div>
          </div>
          <div v-else class="more" style="width: 10em">没有更多的数据啦！</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  props: {},
  data() {
    return {
      m: false,
      MoreShow: true,
      ListShow: false,
      moreBox: true,
      screenWidth: document.body.clientWidth,
      list: [],
      options: [],
      form: {
        type: 1,
        name: "",
        job_cate_id: "",
        work_l: "",
        page: 1,
        rows: 10,
      },
    };
  },
  computed: {},
  created() {
    if (this.screenWidth < 766) {
      this.m = true;
      console.log(this.m);
    }
    // 页面创建后回调
    this.getJobList();
    this.postJobTypelist();
    // 在sessionStorage里面获取保存的值并给form赋值
    // if (window.sessionStorage) {
    //   const name = window.sessionStorage.getItem("Cname");
    //   const work = window.sessionStorage.getItem("Cwork");
    //   if (name == "null" || work == "null") {
    //     this.form.name = "";
    //     this.form.work_l = "";
    //   } else {
    //     this.form.name = name;
    //     this.form.work_l = work;
    //   }

    //   this.ClickQuery();
    // }
  },
  mounted() {},
  watch: {},
  methods: {
    //页面创建后首次加载的岗位列表
    getJobList() {
      this.$http.post("/api/Job/list", { type: 1 }).then((res) => {
        this.list = res.content.content;
        console.log(res);
      });
    },
    // 岗位类别
    postJobTypelist() {
      this.$http.post(this.$api.getJobType).then((res) => {
        this.options = res.content.content;
        let a = {
          name: "请选择岗位类别",
          type_id: 0,
        };
        this.options.unshift(a);
      });
    },
    // 点击查询岗位筛选
    ClickQuery() {
      this.$http.post("/api/Job/list", this.form).then((res) => {
        console.log("this.res", res);
        if (res.content.content != "") {
          this.list = res.content.content;
          this.page = 1;
          this.moreBox = true;
          this.ListShow = false;
          this.MoreShow = true;
        } else {
          this.moreBox = false;
          this.ListShow = true;
          this.MoreShow = false;
        }
      });
      // 在sessionStorage里面添加变量并保存form内容
      // if (window.sessionStorage) {
      //   let Cname = this.form.name;
      //   let Cwork = this.form.work_l;
      //   window.sessionStorage.setItem("Cname", Cname);
      //   window.sessionStorage.setItem("Cwork", Cwork);
      // }
    },
    // 点击跳转对应的岗位详情并携带id
    toDetails(id) {
      // console.log(id);

      this.$router.push({
        path: "/campus/details",
        query: {
          id: id,
        },
      });
    },
    // list数组追加，下拉加载更多
    AddList() {
      this.form.page++;
      this.$http.post("/api/Job/list", this.form).then((res) => {
        if (res.content.content != "") {
          this.list = this.list.concat(res.content.content);
          this.MoreShow = true;
        } else {
          this.MoreShow = false;
          this.form.page = 1;
        }
      });
      console.log(this.form.page, this.form.rows, this.list);
    },
  },
  components: {
    Footer,
  },
};
</script>

<style lang="less" scoped>
.society {
  margin-top: 0.8rem;
  background-color: #e9e9e9;
  .banner {
    width: 100%;
    height: 4rem;
    background-image: url(../assets/img/compus_ban.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .container {
    .screen {
      width: 100%;
      height: 1rem;
      display: flex;
      justify-content: space-around;
      h2 {
        font-size: 0.18rem;
        display: block;
        position: relative;
        line-height: 1rem;
      }
      h2::after {
        content: "";
        position: absolute;
        left: 0%;
        // transform: translateX(-50%);
        right: 0;
        bottom: 0.3rem;
        width: 4em;
        height: 2px;
        border-bottom: 2px solid #f27901;
      }
      .sle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        .sle_item {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }
    }
    .list {
      padding-bottom: 1rem;
      .list_item {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 0.4rem;
        // height: 7rem;
        // overflow: auto;
        .item {
          width: 48%;
          height: 1rem;
          margin-bottom: 0.1rem;
          display: flex;
          justify-content: space-between;
          .item_l {
            h4 {
              margin: 0.25rem 0 0.1rem 1em;
            }
            p {
              margin-left: 0.16rem;
              font-size: 0.12rem;
              color: #adadad;
            }
          }
          .item_r {
            line-height: 1rem;
            button {
              width: 0.8rem;
              height: 0.28rem;
              font-size: 0.12rem;
              color: #fff;
              background-color: #f27901;
              border: #f27901;
              margin-right: 0.12rem;
              cursor: pointer;
              border-radius: 0.05rem;
            }
          }
        }
      }
      .more {
        position: relative;
        top: 0.5rem;
        width: 0.3rem;
        height: 0.3rem;
        left: 50%;
        transform: translateX(-50%);
        .more_box {
          position: absolute;
          cursor: pointer;
          animation: bounce-down 1s linear infinite;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .more_btm {
          top: 0.1rem;
        }
        @keyframes bounce-down {
          25% {
            transform: translateY(-4px);
          }
          50% {
            transform: translateY(0);
          }
          75% {
            transform: translateY(4px);
          }
          100% {
            transform: translateY(0);
          }
        }
      }
    }
  }
  @media only screen and (max-width: 766px) {
		.banner{
			background-position: 40% center;
		}
    .container {
      padding: 0 0.2rem;
      .screen {
        height: 2.6rem;
        flex-flow: column;
        padding: 0.1rem;
        justify-content: space-evenly;
        h2 {
          left: 0;
          line-height: 2;
          border-bottom: 1px solid #e9e9e9;
          font-size: 0.32rem;
        }
        h2::after {
          bottom: 0;
        }
        .main {
          .sle {
            flex-wrap: wrap;
            .sle_item {
              width: 33.33%;
            }
            input {
              border: none;
            }
            button {
              width: 100%;
            }
          }
        }
      }
      .list {
        .list_item {
          margin-top: 0.1rem;
          .item {
            width: 100%;
            height: 1.6rem;
            padding: 0.1rem;
            .item_l {
              display: flex;
              flex-flow: column;
              justify-content: space-evenly;
              h4 {
                font-size: 0.28rem;
                margin: 0;
              }
              p {
                margin-left: 0;
                font-size: 0.24rem;
              }
            }
            .item_r {
              button {
                width: 1.4rem;
                height: 0.48rem;
                font-size: 0.24rem;
              }
            }
          }
        }
        .more {
          width: 0.5rem;
          height: 0.5rem;
        }
        .more_btm {
          top: 0.2rem !important;
        }
      }
    }
  }
  // @media only screen and (max-width: 500px) {
  //   .Mobile {
  //     .screen {
  //       h2 {
  //         height: 1rem;
  //       }
  //     }
  //   }
  // }
}
@media only screen and (max-width: 766px) {
  .society {
    margin-top: 1.4rem;
  }
}
</style>
